import { AnimatePresence, motion } from 'framer-motion';
import styles from '../CoachAcceptModal/CoachAcceptModal.module.css';

const TraitCooldownModal = ({ isOpen, daysRemaining, onClose }) => {
  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          className={styles.overlay}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
        >
          <motion.div
            className={styles.modal}
            initial={{ scale: 0.9, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.9, opacity: 0 }}
            transition={{ duration: 0.3 }}
          >
            <p className={styles.title}>
              You can only take the Trait Assessment once every 6 months.
            </p>
            <p className={styles.subtitle}>
              You have <strong>{daysRemaining}</strong> day{daysRemaining !== 1 ? 's' : ''} remaining.
            </p>
            <button
              className={styles.closeButton}
              onClick={onClose}
              aria-label="Close Cooldown Modal"
            >
              Okay
            </button>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default TraitCooldownModal;